import {BaseWidget} from "./BaseWidget";
import {createSearcherWindow, NamaGridWidget} from "../grid/NamaGridWidget";
import * as GridSize from "../constants/GridSize";
import * as OwnerType from "../constants/OwnerType";
import * as CommonConstants from "../constants/CommonConstants";
import {areEqual, isNotEmptyOrNull, isNullOrUndefined} from "../common/NamaCommon";
import {parseString, toString} from "../common/FieldTypesUtils";
import {toCSVLineWithSep} from "../common/StringUtils";
import {NamaKendoWindow, NamaWindowBtnData} from "../views/NamaKendoWindow";
import {csvLineToList} from "../views/charts/DashBoardResultSetUtil";
import {isMobileDevice} from "../common/GUIUtilities";
import {createSearchContextInfo} from "../actions/BaseDispatcher";

const detailId = "details";

export class QuestionListWidget extends BaseWidget {
    constructor(req, questionField, questionFieldsEditor, questionTitle) {
        super(req);
        let that = this;
        that.questionField = questionField;
        that.editor = questionFieldsEditor;
        that.questionTitle = questionTitle;
        that.columnId = detailId + "." + questionField.id;
        that.flatObject = new Map();
    }

    createElement(style) {
        let that = this;
        return $(`<div class="form-widgets col-md-3" id="${this.elementId}" nid="${this.id}"><div class = "form-group row">
        <div class="fieldLabel col-md-3" style="display: block"><label class="control-label" for="questionListBtn" style="padding-top: 7px">${that.questionTitle}</label></div>
                          <button id = "questionListBtn" class="col-md-3">...</button><label id = "qlCounterLabel" class="col-md-3" style="padding-top: 7px"></label></div></div>`);
    }

    afterAttach() {
        let that = this;
        that.findElement().find("#questionListBtn").kendoButton({
            click: e => {
                that.showDialog();
            }
        });
    }

    showDialog() {
        let that = this;
        let colWidth = "43em";
        let width = "60%";
        let height = "65%";
        if (isMobileDevice()) {
            width = "90%";
            height = "50%";
            colWidth = ($("body").width() / 2) + "px";
        }
        let block = {"columns": [{"id": that.columnId, "width": colWidth}], "gridSize": GridSize.Small, "fieldId": detailId};
        let metaData = {fieldsMetaData: [], detailFields: new Map()};
        metaData.owner = {ownerType: OwnerType.Entity, ownerId: ""};
        let fieldMetaData = fieldMetaDataFrom(that.questionField.metaData);
        fieldMetaData.fieldId = that.columnId;
        fieldMetaData.parentDetail = {"fieldId": detailId};
        metaData.fieldsMetaData.push(fieldMetaData);
        let detailfieldMetaData = fieldMetaDataFrom(that.questionField.metaData);
        detailfieldMetaData.fieldId = detailId;
        detailfieldMetaData.subFields = [fieldMetaData];
        metaData.fieldsMetaData.push(detailfieldMetaData);
        metaData.detailFields.set(detailId, detailfieldMetaData);
        if (isNotEmptyOrNull(fieldMetaData.referencedEntityType) && fieldMetaData.referencedEntityType.startsWith("$")) {
            let paramName = fieldMetaData.referencedEntityType.substring(1);
            let filledQuestionField = null;
            let filtered = that.editor.getQuestionFields().filter((q) => areEqual(paramName, q.id));
            if (filtered)
                filledQuestionField = filtered[0];
            if (filledQuestionField)
                fieldMetaData.referencedEntityType = filledQuestionField.value;
        }
        let window = new NamaKendoWindow(that.questionTitle, new NamaWindowBtnData("ok", () => {
            that.onCloseWidget();
            window.closeWindow();
        }), new NamaWindowBtnData("cancel"), width, null, null, true);
        window.height = height;
        that.metaData = metaData;
        that.entityType = fieldMetaData.referencedEntityType;
        that.grid = new NamaGridWidget({
            owner: that,
            grid: block,
            metaData: metaData,
            id: block.fieldId,
            hasSelectBox: true
        });
        that.grid.questionList = true;
        that.content = window.content;
        window.content.append(that.grid.createElement());
        that.grid.afterAttach();
        window.gridWidget = that.grid;
        that.flatObject.set(detailId, that.getFieldValue(detailId));
        let showSelector = () => {
            if (that.grid.isLastLineEmpty()) {
                that.grid.focusColumnInLastRow(that.columnId);
            } else {
                let ownerGrid = that.grid._kendoGrid();
                let gridData = ownerGrid.dataSource.data();
                let insertionStartIndex = gridData.length - 1;
                that.grid.appendEmptyRows(1, insertionStartIndex, true).then(() => {
                    that.grid.focusColumnInLastRow(that.columnId);
                });
            }
            let contextInfo = createSearchContextInfo(that.columnId, -1, that.grid);
            contextInfo.inQuestionList = true;
            createSearcherWindow(that.grid, that.entityType, (ref) => {
                that.grid.refSelectionCallBack(that.columnId, ref);
            }, contextInfo, false, "");
        };
        window.showWindow(showSelector);
    }

    counterLabel() {
        return this.findElement().find("#qlCounterLabel");
    }

    onCloseWidget() {
        let that = this;
        that.updateLabelText();
    }

    updateLabelText() {
        let that = this;
        let counterLabel_ = that.counterLabel();
        if (!counterLabel_.length)
            setTimeout(() => that.updateLabelText(), 500);
        let value = that.getFieldValue(detailId);
        let dataCount = "";
        if (value && value.length)
            dataCount = value.length;
        counterLabel_.text(dataCount + "");
    }

    readValueFromElement() {
        let that = this;
        let list = that.getFieldValue(detailId);
        if (!list || !list.length)
            return null;
        let fieldValues = [];
        for (let i = 0; i < list.length; i++) {
            let dataItem = list[i];
            let value = dataItem[that.questionField.id];
            if (!value)
                continue;
            fieldValues.push(toString(that.questionField.fieldType, value));
        }
        return toCSVLineWithSep(CommonConstants.LIST_PARAMS_SEP, fieldValues);
    }

    setValueInElement(value) {
        let that = this;
        let strs = csvLineToList(CommonConstants.LIST_PARAMS_SEP, value);
        let list = that.getFieldValue(detailId);
        if (!list)
            list = [];

        for (let i = 0; i < strs.length; i++) {
            if (list.length <= i) {
                let o = {};
                o[that.columnId.substr(detailId.length + 1, that.columnId.length)] = parseString(strs[i], that.questionField.fieldType)
                list.push(o);
            }
        }
        that.setFieldValue(detailId, list);
    }

    setFieldValue(fieldId, value, row) {
        let that = this;
        let invalidRow = isNullOrUndefined(row) || row === -1;
        if (invalidRow)
            that.flatObject.set(fieldId, value);
        else
            that.flatObject.get(detailId) [row] = value;
        that.updateLabelText();
    }

    getFieldValue(fieldId, row) {
        let that = this;
        let invalidRow = isNullOrUndefined(row) || row === -1
        if (invalidRow)
            return that.flatObject.get(fieldId);
        return that.flatObject.get(fieldId)[row];
    }

    getPlaceExtraFieldFilterId() {
    }

    rootElement() {
        return this.content;
    }

    isViewOnlyMode() {
        return true;
    }
}

export function fieldMetaDataFrom(metaData) {
    if (metaData.fieldInformation)
        return metaData;
    return $.extend(true, {}, metaData);
}